import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import materialRoutes from 'app/views/material-kit/MaterialRoutes';
import profileRoutes from './views/profile/ProfileRoutes';

// session pages
const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const JwtRegister = Loadable(lazy(() => import('app/views/sessions/JwtRegister')));
const ForgotPassword = Loadable(lazy(() => import('app/views/sessions/ForgotPassword')));

const PrivacyPolicy = Loadable(lazy(() => import('app/views/privacyPolicy/PrivacyPolicy')));
// echart page
const AppEchart = Loadable(lazy(() => import('app/views/charts/echarts/AppEchart')));

// dashboard page
const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));
const Volunteer = Loadable(lazy(() => import('app/views/volunteer/Signup')));
const AddUser = Loadable(lazy(() => import('app/views/userManagement/AddUser')));
const Users = Loadable(lazy(() => import('app/views/userManagement/UsersList')));
const Membership = Loadable(lazy(() => import('app/views/membership/Membership')));
const Donation = Loadable(lazy(() => import('app/views/donation/DonationForm')));
const Thalassemia = Loadable(lazy(() => import('app/views/thalassemia/Thalassemia')));
const BloodDonationForm = Loadable(lazy(() => import('app/views/donation/BloodDonationForm')));
const BloodDonationList = Loadable(lazy(() => import('app/views/bloodDonation/BloodDonationList')));
const DeleteAccount = Loadable(lazy(() => import('app/views/deleteAccount/DeleteAccount')));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      ...profileRoutes,
      // dashboard route
      {
        path: '/',
        element: <Analytics />
        // auth: authRoles.admin
      },

      // e-chart rooute
      {
        path: '/charts/echarts',
        element: <AppEchart />
        // auth: authRoles.editor
      }
    ]
  },

  // session pages route
  { path: '/session/404', element: <NotFound /> },
  { path: '/session/signin', element: <JwtLogin /> },
  { path: '/session/signup', element: <JwtRegister /> },
  { path: '/session/forgot-password', element: <ForgotPassword /> },

  { path: '/privacyPolicy/PrivacyPolicy', element: <PrivacyPolicy /> },
  { path: '/account/delete', element: <DeleteAccount /> },
  // user management route
  { path: '/userManagement/adduser', element: <AddUser /> },
  { path: '/userManagement/users', element: <Users /> },

  { path: '/', element: <Navigate to="dashboard" /> },
  { path: '*', element: <NotFound /> },
  // { path: '/volunteer/signup', element: <Volunteer /> },
  // { path: '/membership/signup', element: <Membership /> },
  // { path: '/donation-form', element: <Donation /> },
  // { path: '/thalassemia', element: <Thalassemia /> },
  // { path: '/blood-donation-form', element: <BloodDonationForm /> },
  { path: '/bloodDonation/BloodDonationList', element: <BloodDonationList /> }
];

export default routes;
